export const sxStyle = {
  centerItemsFlex: {
    width: '100%',
    display: 'flex',
  },

  centerInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 2,
  },

  centerBaggage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  equipaje: {
    color: '#000',
    fontWeight: 700,
    fontSize: 14,
    textAlign: 'center',
    lineHeight: 1,
    display: { xs: 'none', sm: 'block' },
  },
};
